/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBitrix2416 = forwardRef<SVGSVGElement, IconBaseProps>(function IconBitrix2416(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" fill="#0BBBEF" />
            <path
                d="M3 11.333h4.824v-1.069h-3.18C5.085 8.51 7.77 8.126 7.77 6.18c0-1.041-.712-1.809-2.22-1.809a5.27 5.27 0 0 0-2.302.549l.329.986c.493-.246 1.069-.466 1.781-.466.548 0 1.07.247 1.07.877 0 1.426-3.153 1.535-3.427 5.016Zm4.961-1.7h3.097v1.7h1.234v-1.7h1.041v-1.04h-1.041V4.37h-.905l-3.426 4.44v.823Zm1.398-.986 1.754-2.357c0 .192-.055.795-.055 1.343v.987h-.822c-.247 0-.713.027-.877.027Z"
                fill="#fff"
            />
        </SVGContainer>
    );
});

const IconBitrix2424 = forwardRef<SVGSVGElement, IconBaseProps>(function IconBitrix2424(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z" fill="#0BBBEF" />
            <path
                d="M4.5 17h7.236v-1.604h-4.77c.659-2.63 4.688-3.206 4.688-6.125 0-1.563-1.07-2.714-3.33-2.714a7.904 7.904 0 0 0-3.454.822l.493 1.48c.74-.37 1.604-.699 2.673-.699.822 0 1.603.37 1.603 1.316 0 2.138-4.728 2.302-5.139 7.524Zm7.442-2.55h4.645V17h1.85v-2.55H20V12.89h-1.562V6.557H17.08l-5.14 6.66v1.234Zm2.097-1.48 2.63-3.535c0 .288-.082 1.192-.082 2.015v1.48h-1.233c-.37 0-1.069.04-1.315.04Z"
                fill="#fff"
            />
        </SVGContainer>
    );
});

export const IconBitrix24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconBitrix24(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <IconBitrix2416 {...iconProps} />;
        case '24':
            return <IconBitrix2424 {...iconProps} />;
        default:
            return <IconBitrix2424 {...iconProps} />;
    }
});
